import { render } from "./Patents.vue?vue&type=template&id=d6fc3abc"
import script from "./Patents.vue?vue&type=script&lang=js"
export * from "./Patents.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__